import { useLayoutEffect, useRef } from "preact/hooks";
import { advanceCard, cards, cardIndex } from "./state";

export function CueCards({ running }: { running: boolean }) {
  const content = useRef<HTMLDivElement>(null);
  const text = useRef<HTMLParagraphElement>(null);
  const card = cards.value[cardIndex.value];
  const last = cardIndex.value === cards.value.length - 1;
  const pause = card?.words.at(-1)?.pauseAfterMs || 0;

  useLayoutEffect(
    function () {
      const container = content.current;
      const paragraph = text.current;
      if (!container || !paragraph) return;
      function fit() {
        if (!container || !paragraph || !container.clientHeight) return;
        paragraph.style.fontSize = "";
        const preferred = parseFloat(getComputedStyle(paragraph).fontSize);
        let size = preferred;
        while (paragraph.scrollHeight > container.clientHeight && size > 1) {
          size--;
          paragraph.style.fontSize = `${size}px`;
        }
      }
      const observer = new ResizeObserver(fit);
      observer.observe(container);
      fit();
      return () => observer.disconnect();
    },
    [card],
  );

  return (
    <button
      class="cue-card"
      onClick={advanceCard}
      disabled={!running || !card}
      aria-label={last ? "Last cue card. Finish when ready." : "Next cue card"}
    >
      <span class="cue-card-heading" aria-live="polite">
        Card {cards.value.length ? cardIndex.value + 1 : 0} /{" "}
        {cards.value.length}
      </span>
      <div class="cue-card-content" ref={content}>
        <p ref={text}>
          {card?.words.map((word, index) => (
            <span
              key={index}
              class={`caption-word intensity-${word.intensity}`}
            >
              {index === card.words.length - 1 ? word.text.trimEnd() : word.text}
            </span>
          ))}
        </p>
      </div>
      <span class="cue-card-hint">
        {pause > 0 && (
          <span>
            Pause after · {pause / 1000}s<br />
          </span>
        )}
        {!running
          ? "Rehearse or record to begin"
          : last
            ? "Last card · Finish when ready"
            : "Tap anywhere on the preview for the next card"}
      </span>
    </button>
  );
}
